(() => {
  const hceI18n = window.hceI18n || {};
  const DESIRED_FILTERS = ['ring gauge', 'length', 'smoking time', 'price'];
  const CUBAN_CHILD_COLLECTIONS = new Set([
    'bolivar', 'cohiba', 'cuaba', 'diplomaticos', 'el-rey-del-mundo',
    'flor-de-cano', 'fonseca', 'h-upmann', 'hoyo-de-monterrey',
    'jose-l-piedra', 'juan-lopez', 'la-gloria-cubana', 'montecristo',
    'quai-dorsay', 'partagas', 'por-larranaga', 'punch',
    'rafael-gonzales', 'ramon-allones', 'romeo-y-julieta',
    'san-cristobal', 'sancho-panza', 'trinidad', 'robaina',
    'vegueros', 'cigarillos', 'custom-rolled-cigars'
  ]);
  const SPECIAL_COLLECTION_ABOUT = {
    'all-cuban-cigars': {
      title: 'CUBAN CIGARS',
      text: 'A broad view of our Cuban cigar catalogue, including current production, special releases, vintage and collectible stock.'
    },
    'new-world-cigars': {
      title: 'NEW WORLD CIGARS',
      text: 'Premium cigars produced outside Cuba, grouped here for customers who want to browse the New World selection in one place.'
    },
    'vintage-and-rare-cuban-cigars': {
      title: 'VINTAGE & RARE',
      text: 'This collection brings together mature, vintage and collectible Cuban cigars selected for provenance, condition and rarity. Availability changes as individual boxes and limited quantities enter or leave stock.'
    },
    'limited-edition-cigars': {
      title: 'LIMITED EDITIONS'
    },
    'regional-edition-cigars': {
      title: 'REGIONAL EDITIONS',
      text: 'Regional Editions are limited-production Habanos created for selected countries and markets. This collection brings together current and past regional releases available from Havana Cigar Exchange.'
    }
  };
  let facetObserver = null;
  let facetObserverTimer = null;

  const normalize = (value = '') => String(value)
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const getCollectionHandle = () => {
    const match = window.location.pathname.match(/^\/collections\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  };

  const initCollectionUiStyles = () => {
    if (document.getElementById('hce-collection-qa-styles')) return;
    const style = document.createElement('style');
    style.id = 'hce-collection-qa-styles';
    style.textContent = `
      @media (max-width: 989px) {
        body.hce-cigar-collection #main-collection-filters .hce-cigar-filter-panel.hce-panel-open {
          grid-column: 1 / -1 !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const initCollectionHeader = () => {
    if (!document.body?.classList.contains('lx-template--collection')) return;
    const intro = document.querySelector('.hce-collection-intro');
    if (!intro || !intro.querySelector('.hce-collection-intro__summary')) return;

    const handle = getCollectionHandle();
    const special = SPECIAL_COLLECTION_ABOUT[handle];
    const pageTitle = intro.querySelector('.hce-collection-intro__title')?.textContent?.trim() || '';
    let details = intro.querySelector('.hce-collection-intro__about');

    const isEnglish = (document.documentElement.lang || 'en').toLowerCase().startsWith('en');
    const aboutLabel = hceI18n.about || 'About';
    const localisedSpecialText = {
      'all-cuban-cigars': hceI18n.collectionAllCuban,
      'new-world-cigars': hceI18n.collectionNewWorld,
      'vintage-and-rare-cuban-cigars': hceI18n.collectionVintageRare,
      'regional-edition-cigars': hceI18n.collectionRegional
    }[handle] || '';

    if (details && special?.title) {
      const summary = details.querySelector('summary');
      if (summary) {
        const visibleTitle = isEnglish ? special.title : (pageTitle || special.title);
        summary.textContent = `${aboutLabel} ${visibleTitle} `;
        const plus = document.createElement('span');
        plus.setAttribute('aria-hidden', 'true');
        plus.textContent = '+';
        summary.appendChild(plus);
      }
      return;
    }

    if (details) return;

    const aboutTitle = isEnglish ? (special?.title || pageTitle.toUpperCase()) : (pageTitle || special?.title || '');
    let aboutText = isEnglish ? (special?.text || '') : localisedSpecialText;

    if (!aboutText && CUBAN_CHILD_COLLECTIONS.has(handle)) {
      if (handle === 'custom-rolled-cigars') {
        aboutText = isEnglish
          ? 'Browse our current selection of custom rolled Cuban cigars, with availability changing as individual batches enter or leave stock.'
          : (hceI18n.collectionCustomRolled || '');
      } else {
        aboutText = isEnglish
          ? `Browse our current selection of ${pageTitle} Cuban cigars, including current production, special releases and vintage stock where available.`
          : (hceI18n.collectionCubanChild || '');
      }
    }

    if (!aboutText || !aboutTitle) return;

    details = document.createElement('details');
    details.className = 'hce-collection-intro__about';
    const summary = document.createElement('summary');
    summary.append(document.createTextNode(`${aboutLabel} ${aboutTitle} `));
    const plus = document.createElement('span');
    plus.setAttribute('aria-hidden', 'true');
    plus.textContent = '+';
    summary.appendChild(plus);
    const content = document.createElement('div');
    content.className = 'hce-collection-intro__about-content rte';
    content.textContent = aboutText;
    details.append(summary, content);
    intro.appendChild(details);
  };

  const scopeExpandSearch = () => {
    if (!document.body?.classList.contains('lx-template--collection')) return;
    const expand = document.querySelector('.hce-expand-search');
    if (!expand) return;
    if (!CUBAN_CHILD_COLLECTIONS.has(getCollectionHandle())) expand.remove();
  };

  const getGroupLabel = (group) => {
    const heading = group?.querySelector('.filter-drawer-category-heading, .accordion-title');
    let label = normalize(heading?.textContent || '');
    const aliases = [
      [hceI18n.ringGauge, 'ring gauge'],
      [hceI18n.lengthFilter, 'length'],
      [hceI18n.smokingTime, 'smoking time'],
      [hceI18n.price, 'price'],
      [hceI18n.maximumPrice, 'price']
    ];
    for (const [localised, canonical] of aliases) {
      if (localised && label === normalize(localised)) return canonical;
    }
    if (label === 'maximum price') label = 'price';
    return label;
  };

  const closeFilterPanel = (group) => {
    const title = group?.querySelector('.accordion-title');
    const panel = title?.nextElementSibling || group?.querySelector('.accordion-panel');
    if (!title || !panel) return;
    panel.style.height = null;
    panel.classList.remove('panel-open');
    panel.setAttribute('aria-hidden', 'true');
    title.classList.remove('active');
    title.setAttribute('aria-expanded', 'false');
    group.classList.remove('hce-panel-open');
  };

  const initCompactCollectionFacets = (root = document) => {
    if (!document.body?.classList.contains('lx-template--collection')) return;
    const filtersRoot = root.querySelector?.('#main-collection-filters') || document.querySelector('#main-collection-filters');
    if (!filtersRoot) return;
    const categories = filtersRoot.querySelector('.filter-drawer-categories');
    if (!categories) return;

    const groups = Array.from(categories.querySelectorAll('.filter-drawer-category-group'));
    const labels = new Set(groups.map(getGroupLabel));
    const isCigarCollection = DESIRED_FILTERS.every((label) => labels.has(label));

    document.body.classList.remove('hce-brand-collection');
    if (!isCigarCollection) {
      document.body.classList.remove('hce-cigar-collection');
      return;
    }

    document.body.classList.add('hce-cigar-collection');
    const disclosure = filtersRoot.querySelector('.mobile-facets__disclosure');
    if (disclosure) {
      disclosure.setAttribute('open', '');
      disclosure.classList.add('hce-compact-facets-open');
    }

    const visibleGroups = [];
    groups.forEach((group) => {
      const label = getGroupLabel(group);
      const order = DESIRED_FILTERS.indexOf(label);
      group.classList.remove('hce-brand-filter-panel', 'hce-brand-filter-panel--hidden', 'hce-brand-filter-panel--price');

      if (order === -1) {
        group.classList.remove('hce-cigar-filter-panel', 'hce-cigar-filter-panel--price', 'hce-panel-open');
        group.classList.add('hce-cigar-filter-panel--hidden');
        return;
      }

      group.classList.remove('hce-cigar-filter-panel--hidden');
      group.classList.add('hce-cigar-filter-panel');
      group.dataset.hceCigarFilterOrder = String(order);
      group.classList.toggle('hce-cigar-filter-panel--price', label === 'price');
      const panel = group.querySelector('.accordion-panel');
      group.classList.toggle('hce-panel-open', Boolean(panel?.classList.contains('panel-open')));
      visibleGroups.push(group);
    });

    if (filtersRoot.dataset.hceCompactOrderReady !== 'true') {
      visibleGroups
        .sort((a, b) => Number(a.dataset.hceCigarFilterOrder) - Number(b.dataset.hceCigarFilterOrder))
        .forEach((group) => categories.appendChild(group));
      filtersRoot.dataset.hceCompactOrderReady = 'true';
    }

    visibleGroups.forEach((group) => {
      const title = group.querySelector('.accordion-title');
      if (!title || title.dataset.hceCompactFilterBound === 'true') return;
      title.dataset.hceCompactFilterBound = 'true';
      title.addEventListener('click', () => {
        window.setTimeout(() => {
          const panel = title.nextElementSibling || group.querySelector('.accordion-panel');
          const isOpen = Boolean(panel?.classList.contains('panel-open'));
          group.classList.toggle('hce-panel-open', isOpen);
          if (!isOpen) return;
          visibleGroups.forEach((other) => {
            if (other !== group) closeFilterPanel(other);
          });
        }, 0);
      });
    });

    filtersRoot.dataset.hceCompactFiltersReady = 'true';
  };

  const initOutsideFilterClose = () => {
    if (document.documentElement.dataset.hceCompactOutsideClose === 'true') return;
    document.documentElement.dataset.hceCompactOutsideClose = 'true';
    document.addEventListener('click', (event) => {
      if (!document.body?.classList.contains('hce-cigar-collection')) return;
      if (event.target.closest('.hce-cigar-filter-panel')) return;
      document.querySelectorAll('#main-collection-filters .hce-cigar-filter-panel.hce-panel-open').forEach(closeFilterPanel);
    });
  };

  const initFacetObserver = () => {
    const filtersRoot = document.querySelector('#main-collection-filters');
    if (!filtersRoot || filtersRoot.dataset.hceCompactObserverReady === 'true') return;
    filtersRoot.dataset.hceCompactObserverReady = 'true';
    facetObserver?.disconnect();
    facetObserver = new MutationObserver(() => {
      window.clearTimeout(facetObserverTimer);
      facetObserverTimer = window.setTimeout(() => {
        scopeExpandSearch();
        initCompactCollectionFacets(document);
      }, 30);
    });
    facetObserver.observe(filtersRoot, { childList: true, subtree: true });
  };

  const init = (root = document) => {
    initCollectionUiStyles();
    initCollectionHeader();
    scopeExpandSearch();
    initCompactCollectionFacets(root);
    initOutsideFilterClose();
    initFacetObserver();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target || document));
})();
